import Lottie from 'lottie-react'
import loadingAnimation from '../../assets/loading-animation.json'

export const IdeyaSpinner = () => {
  return <Lottie animationData={loadingAnimation} loop={true} />
}
